import { shallowRef, ShallowRef } from "vue";

/**
 * Hook pour la manipulation d'un tableau réactif (shallow)
 * @param arr Valeur initiale du tableau
 * @returns shallowRefArray (ShallowRef<T[]>), doChangeArray (setter), doAddToArray (push un élément)
 */
function useArray<T = any>(arr: T[] = []) {
  const shallowRefArray: ShallowRef<T[]> = shallowRef(arr);

  const doChangeArray = (newArray: T[]) => {
    shallowRefArray.value = newArray;
  };

  const doAddToArray = (value: T) => {
    shallowRefArray.value = [...shallowRefArray.value, value];
  };

  return {
    shallowRefArray,
    doChangeArray,
    doAddToArray,
  };
}

export default useArray;
